export default __webpack_public_path__ + "assets/png/b8cc8bb6780fe233e9bed8013701aba2.png";